export default {
    /**
     * Updates data.
     *
     * @param  {object} state Vuex state.
     * @param  {object} data  New user data.
     */
    setData(state, data) {
        state.data = data;
    },

    /**
     * Updates errors.
     *
     * @param  {object} state   Vuex state.
     * @param  {object} errors  New errors collection..
     */
    setErrors(state, errors) {
        state.errors = errors;
    },

    /**
     * Updates step.
     *
     * @param  {object} state   Vuex state.
     * @param  {object} payload Mutation payload.
     */
    setStep(state, { step, previousStep }) {
        state.previousStep = previousStep !== undefined ? previousStep : state.step;
        state.step = step;
    },

    /**
     * Updates "is registering" state.
     *
     * @param  {object} state   Vuex state.
     * @param  {boolean} isRegistering "is registering" state
     */
    setIsRegistering(state, isRegistering) {
        state.isRegistering = isRegistering;
    },

    /**
     * Updates transition enabled state.
     *
     * @param  {object} state   Vuex state.
     * @param  {boolean} enabled Transition enabled state
     */
    setTransitionEnabled(state, enabled) {
        state.transitionEnabled = enabled;
    },

    /**
     * Updates recently registered state.
     *
     * @param  {object} state   Vuex state.
     * @param  {boolean} recentlyRegistered Recently registered state
     */
    setRecentlyRegistered(state, recentlyRegistered) {
        state.recentlyRegistered = recentlyRegistered;
    },

    /**
     * Sets the fresh state.
     *
     * @param {object} state Vuex state.
     */
    setFreshState(state) {
        // state
        state.isRegistering = false;
        state.transitionEnabled = true;
        state.recentlyRegistered = false;
        // steps
        state.step = 1;
        state.previousStep = 0;
        state.stepsCount = 3;
        // data
        state.data = {};
        state.errors = {};
    },
};
